export const RESPONSE_STATUS_SUCCESS = 'SUCCESS';
export const RESPONSE_STATUS_FAIL = 'FAIL';
export const RESPONSE_STATUS_POLL = 'POLL';
export const RESPONSE_TYPE_ERROR = 'error';
export const RESPONSE_HTTP_NON_SUCCESS = 'HTTP_NON_SUCCESS';

export const FAIL_TYPE_GENERIC = 3;
export const FAIL_TYPE_NEED_VERIFY = 50;
export const FAIL_TYPE_NEED_INITIALIZE = 51;
export const FAIL_TYPE_CODE_EXPIRED = 52;
export const FAIL_TYPE_MOBILE_NUMBER_NOT_FOUND = 53;
export const FAIL_TYPE_EMAIL_NOT_FOUND = 54;
export const FAIL_TYPE_MOBILE_NUMBER_STOPPED = 58;
export const FAIL_TYPE_AUTH_TOKEN_RESENT = 59;
export const FAIL_TYPE_SUGGEST_LOGIN = 61;
export const FAIL_TYPE_MISSING_SESSION = 63;
export const FAIL_TYPE_CONTACT_SUPPORT = 70;

export const AUTH_POLL_SAME_SESSION = 81;
export const AUTH_SUCCESS = 0;
export const AUTH_REQUEST_CANCELLED = 82;

export const DEFAULT_ERROR = 'We had a problem on our side. Please contact us for help.';
export const BAD_PHONE_NUMBER_MESSAGE =
  'There was a problem with the phone number you entered. ' +
  'It may be incorrect or expired, or you may have also had too many failed attempts. Please contact Philo Help.';
export const AUTHENTICATE_ERROR =
  'There was a problem with the phone number you entered ' +
  'or this phone number already has already been sent a sign-in link.';
export const PHONE_AUTHENTICATE_NEED_VERIFY_ERROR =
  'We sent you a message. Please check your phone.';
export const EMAIL_AUTHENTICATE_NEED_VERIFY_ERROR =
  'We sent you a message. Please check your email.';
export const AUTHORIZE_ERROR = 'That code isn’t working. Please try again.';
export const AUTHORIZE_NEED_RESTART_ERROR =
  'We had a problem on our side. Please start over with sign-in.';
export const REGISTER_NEED_RESTART_ERROR =
  'We had a problem on our side. Please start over with sign-up.';
